import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[85vh] flex items-center bg-white overflow-hidden" data-id="element-77">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-78">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-blue-100/30 rounded-full blur-3xl" data-id="element-79" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20" data-id="element-80">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-81">
          {/* Left column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-82">
            <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight text-gray-900 mb-6 leading-[1.1]" data-id="element-83">
              Tu obra entera está en WhatsApp.{' '}
              <span className="text-blue-600" data-id="element-84">Solo no se puede leer.</span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-85">
              Obra Digital convierte el chat de tu obra en una plataforma donde
              el mandante, el ITO y tú entienden qué está pasando en 5 minutos.
              Sin apps nuevas. Sin cambiar cómo trabaja el equipo.
            </p>

            {/* Feature bullets */}
            <div className="space-y-3 mb-10" data-id="element-86">
              {['Mensajes clasificados por avance, decisión y problema', 'Resumen ejecutivo automático cada semana', 'Reporte PDF listo para enviar al mandante'].map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1
            }} className="flex items-start" data-id="element-87">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-88" />
                  <span className="text-gray-700 font-medium" data-id="element-89">{feature}</span>
                </motion.div>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-90">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl" data-id="element-91">
                Probar con mi obra
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-92" />
              </button>
              <a href="#" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-blue-600 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors" data-id="element-93">
                Ver un reporte de ejemplo
              </a>
            </div>
          </motion.div>

          {/* Right column - Dashboard mockup illustration */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-94">
            {/* WhatsApp icon with animated arrow */}
            <motion.div initial={{
            x: -20,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="absolute -left-8 top-1/2 -translate-y-1/2 z-10" data-id="element-95">
              <div className="w-16 h-16 bg-[#25D366] rounded-2xl shadow-lg flex items-center justify-center" data-id="element-96">
                <svg viewBox="0 0 24 24" className="w-9 h-9 text-white" fill="currentColor" data-id="element-97">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-98" />
                </svg>
              </div>
              <motion.div animate={{
              x: [0, 10, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -right-12 top-1/2 -translate-y-1/2" data-id="element-99">
                <ArrowRight className="w-8 h-8 text-blue-600" strokeWidth={2.5} data-id="element-100" />
              </motion.div>
            </motion.div>

            {/* Browser mockup with dashboard */}
            <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden" data-id="element-101">
              {/* Browser chrome */}
              <div className="bg-gray-100 px-4 py-3 border-b border-gray-200 flex items-center gap-2" data-id="element-102">
                <div className="flex gap-1.5" data-id="element-103">
                  <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-104" />
                  <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-105" />
                  <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-106" />
                </div>
                <div className="flex-1 ml-4 bg-white rounded-md px-3 py-1 text-xs text-gray-500" data-id="element-107">
                  obradigital.app
                </div>
              </div>

              {/* Dashboard content */}
              <div className="p-6 bg-gradient-to-br from-gray-50 to-white" data-id="element-108">
                {/* Header */}
                <div className="mb-6" data-id="element-109">
                  <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-110">
                    Proyecto Centro · Semana 3 oct
                  </h3>
                </div>

                {/* KPI cards */}
                <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-111">
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-112">
                    <div className="text-2xl font-bold text-blue-600 mb-1" data-id="element-113">
                      12
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-114">
                      Avances
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-115">
                    <div className="text-2xl font-bold text-green-600 mb-1" data-id="element-116">
                      3
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-117">
                      Decisiones
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-118">
                    <div className="text-2xl font-bold text-amber-600 mb-1" data-id="element-119">
                      2
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-120">
                      Problemas
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-121">
                    <div className="text-2xl font-bold text-purple-600 mb-1" data-id="element-122">
                      5
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-123">
                      Pendientes
                    </div>
                  </div>
                </div>

                {/* Executive summary */}
                <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm mb-4" data-id="element-124">
                  <h4 className="text-sm font-bold text-gray-900 mb-2" data-id="element-125">
                    Resumen de la semana
                  </h4>
                  <div className="space-y-1.5 text-xs text-gray-600 leading-relaxed" data-id="element-126">
                    <p data-id="element-127">Avance del 18% en losa piso 3.</p>
                    <p data-id="element-128">Decisión de cambiar proveedor de fierros.</p>
                    <p data-id="element-129">Retraso de 2 días por lluvia.</p>
                  </div>
                </div>

                {/* Key decisions */}
                <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-130">
                  <h4 className="text-sm font-bold text-gray-900 mb-3" data-id="element-131">
                    Decisiones clave
                  </h4>
                  <div className="space-y-2.5" data-id="element-132">
                    <div className="flex items-center gap-2.5" data-id="element-133">
                      <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center text-xs font-bold text-blue-700" data-id="element-134">
                        JM
                      </div>
                      <div className="flex-1 text-xs text-gray-700" data-id="element-135">
                        Cambio de proveedor aprobado
                      </div>
                      <div className="text-[10px] text-gray-400" data-id="element-136">Mar 12</div>
                    </div>
                    <div className="flex items-center gap-2.5" data-id="element-137">
                      <div className="w-7 h-7 rounded-full bg-green-100 flex items-center justify-center text-xs font-bold text-green-700" data-id="element-138">
                        PC
                      </div>
                      <div className="flex-1 text-xs text-gray-700" data-id="element-139">
                        Inspección programada viernes
                      </div>
                      <div className="text-[10px] text-gray-400" data-id="element-140">Mié 13</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating blue blur */}
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-blue-400/20 rounded-full blur-3xl -z-10" data-id="element-141" />
          </motion.div>
        </div>
      </div>
    </section>;
}